/**
 * ## keyboard control and shortcuts
 *
 * @module src/controllers/init
 */

"use strict";

const conf = require("../../config");
const layout = require("../../components/layout");
const modal = require("../../components/modal");
const component = require("../../components/component");
const chart = require("../../components/chart");
const demo = require("../../controllers/demo");

const drop = (direction, target, data) => {
  if (data === "int") {
    let currentValue = parseInt($(target).val(), 10);
    if (direction === "down") {
      ++currentValue;
      if (currentValue > 25) {
        currentValue = 25;
      }
    } else if (direction === "up") {
      --currentValue;
      if (currentValue < 1) {
        currentValue = 1;
      }
    }
    $(target).val(currentValue);
  } else {
    let currentValue = $(`${target}_value`).data("value");
    let currentDesc = $(target).val();
    if (!currentValue) {
      currentValue = currentDesc;
    }
    if (direction === "down") {
      for (let i = 0; i < data.length - 1; ++i) {
        if (currentValue === data[i].value) {
          currentValue = data[i + 1].value;
          currentDesc = data[i + 1].description;
          break;
        }
      }
    } else if (direction === "up") {
      for (let i = 0; i < data.length; ++i) {
        if (currentValue === data[i].value && i !== 0) {
          currentValue = data[i - 1].value;
          currentDesc = data[i - 1].description;
          break;
        }
      }
    }
    $(`${target}_value`).data("value", currentValue);
    $(target).val(currentDesc);
    if (target === "#modal_addparty_alert") {
      modal.setType(currentValue);
    }
  }
};

const filterAlerts = (kd, alerts) => {
  const location = kd.doc("location")[0];
  if (location.hasOwnProperty("pager") && location.pager === 0) {
    alerts.splice(2, 1);
  }
  if (
    location.hasOwnProperty("emailCollection") &&
    location.emailCollection < 3
  ) {
    if (alerts.length === 5) {
      alerts.splice(3, 1);
    } else {
      alerts.splice(2, 1);
    }
  }
  return alerts;
};

const jump = (target, key, data, mode) => {
  let index = 0;
  switch (mode) {
    case "character": {
      for (let i = 0; i < data.length; ++i) {
        if (key === data[i].description.substring(0, 1)) {
          index = i;
          break;
        }
      }
      break;
    }
    case "number": {
      if (typeof data[parseInt(key, 10) - 1] !== "undefined") {
        index = parseInt(key, 10) - 1;
      }
      break;
    }
    default: {
      break;
    }
  }
  $(target).val(data[index].description);
  $(`${target}_value`).data("value", data[index].value);
  if (target === "#modal_addparty_alert") {
    modal.setType(data[index].value);
  }
};

const init = (kd) => {
  $(document).on("keydown", (event) => {
    if (kd.localstore.data.op_state === "standard") {
      if ($("#component_catch").css("display") === "block") {
        component.destroy();
      }
      switch (event.keyCode) {
        case 9: {
          if ($("#waitlist_quoted_time").css("display") === "block") {
            if ($("#modal_addparty_basic").css("display") === "block") {
              if (event.target.id === "modal_addparty_email") {
                $("#reservation_filter_search").focus();
              }
            } else {
              if (event.target.id === "modal_addparty_customNotes") {
                $("#reservation_filter_search").focus();
              }
            }
          } else {
            if ($("#modal_addparty_basic").css("display") === "block") {
              if (event.target.id === "modal_addparty_createdBy") {
                $("#reservation_filter_search").focus();
              }
            } else {
              if (event.target.id === "modal_addparty_customNotes") {
                $("#reservation_filter_search").focus();
              }
            }
          }
          if (event.target.id === "search_box2") {
            $("#search_box").focus();
          }
          break;
        }
        case 13: {
          if ($("#notification").css("display") === "block") {
            $("#notification_button1").click();
          } else if (
            $("#modal_block").css("display") === "block" &&
            !$("#modal_addparty_customNotes").is(":focus") &&
            !layout.getIsExpanded()
          ) {
            $("#modal_addparty_btn2").click();
          }
          break;
        }
        case 27: {
          if ($("#modal_block").css("display") === "block") {
            $("#modal_addparty_btn1").click();
          } else if (layout.getIsExpanded()) {
            layout.toggleSidebarMax();
            setTimeout(() => {
              layout.hideKeyboard();
            }, 100);
          } else {
            chart.resetZoom();
          }
          $("#component_catch").click();
          break;
        }
        case 32: {
          if (event.altKey) {
            $("#modal_addparty_name").blur();
            if (
              $("#modal_block").css("display") === "none" &&
              !layout.getIsExpanded() &&
              !$("#search_box").is(":focus")
            ) {
              $("#tab_btn_addreservation_wide").click();
              setTimeout(() => {
                $("#modal_addparty_name").val("");
              }, 1);
            } else if ($("#modal_block").css("display") === "block") {
              if ($("#reservations_date_time").css("display") === "block") {
                $("#modal_tabs_btn1").click();
              } else {
                $("#modal_tabs_btn2").click();
              }
            }
            setTimeout(() => {
              $("#modal_addparty_name").focus();
            }, 2);
          } else {
            if (
              $("#modal_block").css("display") === "none" &&
              !layout.getIsExpanded() &&
              !$("#search_box").is(":focus")
            ) {
              $("#tab_btn_addparty_wide").click();
            }
          }
          break;
        }
        case 48: {
          if (event.altKey) {
            demo.start(kd);
          }
          break;
        }
        case 38: {
          if (
            $("#modal_block").css("display") === "block" &&
            $("#modal_addparty_partysize").is(":focus")
          ) {
            drop("up", "#modal_addparty_partysize", "int");
          }
          if (
            $("#modal_block").css("display") === "block" &&
            $("#modal_addparty_quoted").is(":focus")
          ) {
            drop("up", "#modal_addparty_quoted", conf.vars.quoteTimes);
          }
          if (
            $("#modal_block").css("display") === "block" &&
            $("#modal_addparty_alert").is(":focus")
          ) {
            const alertTypes = filterAlerts(
              kd,
              Object.assign([], conf.vars.alertTypes)
            );
            drop("up", "#modal_addparty_alert", alertTypes);
          }
          if (
            $("#modal_block").css("display") === "block" &&
            $("#modal_addparty_preference").is(":focus")
          ) {
            const location = kd.doc("location")[0];
            drop("up", "#modal_addparty_preference", location.preferenceTypes);
          }
          break;
        }
        case 40: {
          // keyboard down arrow
          if (
            $("#modal_block").css("display") === "block" &&
            $("#modal_addparty_partysize").is(":focus")
          ) {
            drop("down", "#modal_addparty_partysize", "int");
          }
          if (
            $("#modal_block").css("display") === "block" &&
            $("#modal_addparty_quoted").is(":focus")
          ) {
            drop("down", "#modal_addparty_quoted", conf.vars.quoteTimes);
          }
          if (
            $("#modal_block").css("display") === "block" &&
            $("#modal_addparty_alert").is(":focus")
          ) {
            const alertTypes = filterAlerts(
              kd,
              Object.assign([], conf.vars.alertTypes)
            );
            drop("down", "#modal_addparty_alert", alertTypes);
          }
          if (
            $("#modal_block").css("display") === "block" &&
            $("#modal_addparty_preference").is(":focus")
          ) {
            const location = kd.doc("location")[0];
            drop(
              "down",
              "#modal_addparty_preference",
              location.preferenceTypes
            );
          }
          break;
        }
        case 49:
        case 50:
        case 51:
        case 52:
        case 53:
        case 54:
        case 55:
        case 56:
        case 57: {
          if (
            $("#modal_block").css("display") === "block" &&
            $("#modal_addparty_partysize").is(":focus")
          ) {
            $("#modal_addparty_partysize").val(
              parseInt(String.fromCharCode(event.keyCode), 10)
            );
          }
          if (
            $("#modal_block").css("display") === "block" &&
            $("#modal_addparty_quoted").is(":focus")
          ) {
            jump(
              "#modal_addparty_quoted",
              String.fromCharCode(event.keyCode),
              conf.vars.quoteTimes,
              "number"
            );
          }
          if (
            $("#modal_block").css("display") === "block" &&
            $("#modal_addparty_alert").is(":focus")
          ) {
            const alertTypes = filterAlerts(
              kd,
              Object.assign([], conf.vars.alertTypes)
            );
            jump(
              "#modal_addparty_alert",
              String.fromCharCode(event.keyCode),
              alertTypes,
              "number"
            );
          }
          break;
        }
        default: {
          break;
        }
      }
    }
  });
};

module.exports = {
  init,
};



/** WEBPACK FOOTER **
 ** ./src/controllers/keyboard/index.js
 **/